import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';
import { ErrorCode } from '@app/origami-api/constants';
import { TopicField } from '../utils/topic-utils';

export namespace ProgramServiceModel {
  export interface Program {
    ClosureReason: string;
    CreatedDate: string;
    Description: string;
    Id: number;
    Name: string;
    ProgramSiteId: number;
    SponsorId: number;
    StatusId: number;
    TherapeuticAreaId?: number;
    TopicFields?: TopicField[];
  }
}

export namespace ProgramServiceOptions {
  export interface GetPrograms {
    searchQuery?: string;
    orderByClause?: string;
    siteId?: number;
  }
}

@Injectable()
export class ProgramService extends ServiceBase {
  serviceUrl = 'ProgramService.svc';

  setProgramStatus(params) {
    return this.origamiPost('/SetProgramStatus', params, null, null, true);
  }

  updateProgram(params) {
    return this.origamiPost('/UpdateProgram', params, null, null, true);
  }

  getPrograms(
    params: ProgramServiceOptions.GetPrograms,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiResponse<ProgramServiceModel.Program[]>> {
    return this.origamiPost('/GetPrograms', params, null, silentErrorCodes, true);
  }

  getProgram(body) {
    return this.origamiPost('/GetProgram', body, null, null, true);
  }

  createProgram(body, silentErrorCodes) {
    return this.origamiPost('/CreateProgram', body, null, silentErrorCodes, true);
  }

  deleteProgram(body: { programId: number }) {
    return this.origamiPost('/DeleteProgram', body, null, null, true);
  }
}
